import { isString } from './isString'

/**
 * ensures that a string is returned
 * @param value the given value
 * @param def optional default value
 * @returns the given value if it is a non-empty string; otherwise the default value if this is a non-empty string; an empty string otherwise
 */
export function ensureString(value: unknown, def?: string): string {
  return isString(value)
    ? (value as string)
    : isString(def)
      ? (def as string)
      : ''
}

/**
 * ensures that a string is returned
 * @param value the given value
 * @param butnot the string that the given value must not be equal to
 * @param def optional default value
 * @returns the given value if it is a non-empty string and is not equal to the "but not" parameter;
 *          otherwise the default value if this is a non-empty string; an empty string otherwise
 */
export function ensureStringButNot(
  value: unknown,
  butnot: string,
  def?: string,
): string {
  if (isString(value) && butnot !== value) {
    return value as string
  } else {
    return isString(def) ? (def as string) : ''
  }
}
